import { UseQueryResult } from '@tanstack/react-query'
import classNames from 'classnames'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import MaterialIcon from '../../../components/MaterialIcon'
import Sorter, { SortControl } from '../../../components/Sorter'
import StickyTable from '../../../components/StickyTable'
import { PaginatedDJResponse } from '../../../types'
import { NotificaClienteType } from '../../../typesCliente'

type NotiicheTableProps = {
  notifiche: UseQueryResult<PaginatedDJResponse<NotificaClienteType>, Error>
  uiFilters: {
    ordering: string
  }
  setFilters: (filters: Record<string, string>) => void
  handleReadClick: (notificaId: number) => void
}

export default function AvvisiTable({ notifiche, uiFilters, setFilters, handleReadClick }: NotiicheTableProps) {
  return (
    <StickyTable isLoading={notifiche?.isLoading}>
      <thead className="position-sticky top-0 bg-white">
        <Sorter
          value={uiFilters.ordering}
          onSortChange={(ordering) =>
            setFilters({
              ordering,
            })
          }
        >
          <tr className="">
            <th style={{ width: '10%' }}>
              <div className="d-flex align-items-center">
                Numero avviso
                <SortControl field="id" />
              </div>
            </th>

            <th style={{ width: '10%' }}>
              <div className="d-flex align-items-center">
                Intervento
                <SortControl field="intervento" />
              </div>
            </th>
            <th style={{ width: '15%' }}>
              <div className="d-flex align-items-center">
                Cliente
                <SortControl field="cliente__ragione_sociale" />
              </div>
            </th>
            <th style={{ width: '15%' }}>
              <div className="d-flex align-items-center">
                Bilancia
                <SortControl field="intervento_data__bilancia_data__matricola" />
              </div>
            </th>
            <th style={{ width: '15%' }}>
              <div className="d-flex align-items-center">
                Titolo
                <SortControl field="titolo" />
              </div>
            </th>
            <th style={{ width: '40%' }}>
              <div className="d-flex align-items-center">
                Messaggio
                <SortControl field="messaggio" />
              </div>
            </th>
            <th style={{ width: '5%' }}>
              <div className="d-flex align-items-center">
                Azioni
                <SortControl field="letta" />
              </div>
            </th>
          </tr>
        </Sorter>
      </thead>
      <tbody>
        {notifiche?.data?.count === 0 && (
          <tr>
            <td colSpan={7} className="text-center">
              Nessun avviso trovato
            </td>
          </tr>
        )}
        {notifiche?.data?.results?.map((notifica) => (
          <tr key={notifica.id}>
            <td className={!notifica.letta ? 'bg-intervento-periodico' : ''}>{notifica.id}</td>
            <td className={!notifica.letta ? 'bg-intervento-periodico' : ''}>
              <div className="d-flex align-items-center">
                <Link
                  data-card-link
                  to={`/interventi/${notifica.intervento}`}
                  className="link-md text-body-secondary"
                  onClick={() => !notifica.letta && handleReadClick(notifica.id)}
                >
                  {notifica.intervento}
                </Link>
              </div>
            </td>
            <td className={!notifica.letta ? 'bg-intervento-periodico' : ''}>
              <div className="d-flex align-items-center">
                <div>
                  <Link className={'link-md'} to={`/clienti/${notifica.cliente}`}>
                    {notifica.cliente_data?.ragione_sociale}
                  </Link>
                  <div className="p-md text-body-secondary">{notifica.cliente_data?.sede_principale?.numero_rea}</div>
                </div>
              </div>
            </td>

            <td className={!notifica.letta ? 'bg-intervento-periodico' : ''}>
              <Link to={`/bilance/${notifica?.intervento_data?.bilancia_data?.id}`}>
                <span className="me-2 link-md text-body-secondary">
                  Bilancia {notifica?.intervento_data?.bilancia_data?.matricola}{' '}
                  {notifica.intervento_data?.bilancia_data?.sigla
                    ? `(${notifica.intervento_data?.bilancia_data?.sigla})`
                    : ''}
                </span>
              </Link>
            </td>
            <td className={!notifica.letta ? 'bg-intervento-periodico' : ''}>{notifica.titolo}</td>
            <td className={!notifica.letta ? 'bg-intervento-periodico' : ''}>{notifica.messaggio}</td>
            <td
              className={classNames({ 'pointer bg-intervento-periodico': !notifica.letta })}
              onClick={() => !notifica.letta && handleReadClick(notifica.id)}
            >
              <OverlayTrigger
                placement="left"
                overlay={
                  !notifica.letta ? (
                    <Popover id="popover-basic">
                      <Popover.Body>
                        <div>{'Segna come letta'}</div>
                      </Popover.Body>
                    </Popover>
                  ) : (
                    <></>
                  )
                }
              >
                <div>
                  <MaterialIcon icon={notifica.letta ? 'drafts' : 'mail'} className="me-2 material-icons-outlined" />
                </div>
              </OverlayTrigger>
            </td>
          </tr>
        ))}
      </tbody>
    </StickyTable>
  )
}
